import React, { StrictMode, Component } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

class RootErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('🔥 [CRITICAL ROOT ERROR]:', error);
    console.error('🔥 [COMPONENT STACK]:', errorInfo?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', fontFamily: 'sans-serif', background: '#fff', color: '#111', maxWidth: '800px', margin: '2rem auto', border: '1px solid #ddd', borderRadius: '8px' }}>
          <h2 style={{ color: '#d32f2f' }}>Application Error Detected</h2>
          <p style={{ fontWeight: 600 }}>{String(this.state.error?.message || this.state.error)}</p>
          <pre style={{ background: '#f5f5f5', padding: '1rem', overflowX: 'auto', fontSize: '12px' }}>
            {this.state.errorInfo?.componentStack || this.state.error?.stack}
          </pre>
          <button 
            onClick={() => { localStorage.clear(); window.location.reload(); }}
            style={{ marginTop: '1rem', padding: '10px 20px', background: '#2874f0', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            Clear Local Cache & Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </StrictMode>,
)

